export const programParticipantsList = {
    GET_LIST_PROGRAM_PARTICIPANTS: "GET_LIST_PROGRAM_PARTICIPANTS",
    GET_LIST_PROGRAM_PARTICIPANTS_SUCCESS : "GET_LIST_PROGRAM_PARTICIPANTS_SUCCESS",
    GET_LIST_PROGRAM_PARTICIPANTS_NULL : "GET_LIST_PROGRAM_PARTICIPANTS_NULL",
    GET_LIST_PROGRAM_PARTICIPANTS_ERROR : "GET_LIST_PROGRAM_PARTICIPANTS_ERROR",
    CLEAR_PROGRAM_PARTICIPANTS_FILTERS: "CLEAR_PROGRAM_PARTICIPANTS_FILTERS",
}


